
import React from 'react'
import "./loading.css";
import loadingImg from "../../images/loading.svg";

export const Loading = () => {
    return (
        <div className="main-page-loading">
            <div className="loading">
                <img src={loadingImg} alt="Imagem de carregamento da página"></img>
            </div>
        </div>
    )
};

